import React from 'react'
import { useParams } from 'react-router-dom'
import ProjectForm from './ProjectForm'

const ProjectEdit = () => {
  const { id } = useParams()

  return (
    <ProjectForm 
      mode="edit" 
      projectId={id}
    />
  )
}

export default ProjectEdit

